import { css } from '@emotion/react';

import { ZeeFontBold } from 'src/styles/font';
import { MediaBP as MQ } from 'src/styles/mediaQuery';
export const recommendedContents = (hasAd = false) => css`
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  max-height: ${hasAd ? 'calc(95% - 290px)' : '95%'};
  overflow-y: auto;
  ::-webkit-scrollbar {
    background-color: transparent;
    border-radius: 2px;
    height: 5px;
    width: 5px;
  }
  ::-webkit-scrollbar-thumb {
    background-color: hsla(0, 0%, 100%, 0.1);
    border-radius: 2.5px;
  }
  ::-webkit-scrollbar-track {
    background-color: #171717;
    border-radius: 6px;
  }
`;
export const recommendedContentsTitle = css`
  margin-bottom: 16px;
  margin-left: 10px;
  ${ZeeFontBold(18)};
  ${MQ.MediaXl} {
    ${ZeeFontBold(24)};
    margin-bottom: 24px;
  }
`;
